"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMaterialData = void 0;
const isMaterialData = (effect) => {
    return effect.materialOutput !== undefined;
};
exports.isMaterialData = isMaterialData;
//# sourceMappingURL=IInteractionEffectUtils.js.map